import React from "react";

function ScheduleTourFormOne({ props }) {
  return (
    <>
      <form className="agent-register-form">
        <p className="schedule-tour-span">
          If you have a buyer’s contract (Exclusive Agency Agreement), please
          enter the date that it will expire.{" "}
        </p>
        <input
       type="date"
          className="form-control agent-register-input-field custom-date-picker"
          id="exampleInputEmail1"
          placeholder="Your Website"
          aria-describedby="emailHelp"
          onChange={(e) => props.setExpiry(e.target.value)}
          // onKeyDown={(e) => e.preventDefault()} 
          max="2099-12-31"

        />

        <p className="schedule-tour-span">
          If you haven’t signed an exclusive agency agreement with a real estate
          agent or worked with a Realtor recently then skip this step.
        </p>

        <span
          onClick={() => props.setIndex(2)}
          className="btn agent-register-button"
        >
          Next
        </span>
        <span
          onClick={() => props.setIndex(2)}
          className="btn schedule-tour-skip-button"
        >
          Skip
        </span>
      </form>
    </>
  );
}

export default ScheduleTourFormOne;
